<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Remises",
          icon: "bi bi-percent",
          route: "discounts-index",
        },
        {
          label: "Nouvelle remise",
          icon: "bi bi-send-dash-fill",
          route: "discounts-create",
        },
      ],
    };
  },
};
</script>
